<template>
<div class="productDownBox">
  <!-- 标题图片 -->
    <p class="productDownTitleImg">
      <img src="../ProductMain/indexImg/titleA.png" alt="">
    </p>
   <h1 class="productDownBoxMdTitle">
    {{title}}
    <span @click="goProductMain">返回<i class="el-icon-arrow-right"></i></span>
   </h1>
    <div class="productDown">
      <div class="productDownItem" v-for="item in productDown" :key="item.ID">
        <!-- <p><span>{{item.Edition}}</span> <a :href='item.Path'>下载</a></p>
        <p>{{item.Info}}</p> -->
        <div class="productDownItemLeft">
          <p class="productDownItemLeftT">{{item.Info}}</p>
          <p class="productDownItemLeftB">{{item.Edition}}</p>
        </div>
        <a class="productDownItemRight" :href='item.Path' >
         <img src="./img/down.png" alt="">
         <p>下载</p>
        </a>
      </div>
   </div>
</div>

</template>

<script>
import { getProductShowDown } from '@/api/product'
// 引入根路径
import request from '@/utils/request'
export default {
  data () {
    return {
      productItem: {},
      productDown: {}, // 下载
      title: ''
    }
  },
  watch: {
    '$route' () {
      // this.getProductShow({ id: this.$route.params.id })
      // this.getProductDown({ id: this.$route.params.id })
    }
  },
  created () {
    // console.log(this.$route.params.id, 'this.$route.params.idthis.$route.params.id')
    this.getProductShowDown({ id: this.$route.params.id })
    this.title = this.$route.params.name
    // this.getProductDown({ id: this.$route.params.id })
  },
  methods: {

    async getProductShowDown (data) {
      const res = await getProductShowDown(data)
      if (res.Msg === '获取成功') {
        this.productDown = res.Data.reverse()
        this.productDown.forEach(item => {
          item.Path = request.defaults.baseURL + item.Path
        })
      }
      // console.log(res, '下载')
    },
    goProductMain () {
      this.$router.back()
    }
  }

}
</script>

<style lang="scss" scoped>
$md:72/192*2;
.productDownBox{
  width: 750px/$md;
  .productDownTitleImg{
    width: 100%;
    img{
      width: 100%;
    }
  }
  .productDownBoxMdTitle{
    font-size: 35px/$md;
    width: 730px/$md;
    margin-left: 10px/$md;
    display: flex;
    justify-content: space-between;
    span{
      font-size: 20px/$md;
    }
    // margin: 0 auto;
  }
}
.pic{
  min-height: 500px/$md;
  p{
    width: 100%;
    img{
      width: 100%;
    }
  }
}
// 产品下在
.productDown{
  width: 750px/$md;
  margin: 0 auto;
  font-size: 20px/$md;
  min-height: 510px/$md;
  margin-bottom: 40px/$md;
  .productDownTitle{
    border: 1px/$md solid rgb(199, 200, 199);
    width: 730px/$md;
    margin: 0 auto;
  }
  .productDownItem{
    height: 144px/$md;
    margin-top:20px/$md;
    display: flex;
    justify-content: space-between;
    color: #333333;
    cursor: pointer;
    padding: 0 20px/$md;
    box-sizing: border-box;
    .productDownItemLeft{
      width: 600px/$md;
      background: #F9FAFC;
      padding:0 20px/$md;
      display: flex;
      justify-content: space-around;
      flex-direction: column;
      box-sizing: border-box;
    transition: all 0.2s;
    box-shadow: 5px/$md 5px/$md 5px/$md rgba(19, 19, 20, 0.15);
      .productDownItemLeftT{
        font-size: 22px/$md;
        height: 55px/$md;
        // display: -webkit-box;
        // -webkit-box-orient: vertical;
        // -webkit-line-clamp: 2;
        overflow: hidden;
        overflow-y: scroll;
        margin: 0;
      }
      .productDownItemLeftB{
        font-size: 18px/$md;
        margin: 0;
      }
    }
    .productDownItemRight{
      width: 100px/$md;
      background: #F9FAFC;
      padding: 30px/$md 23px/$md;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      transition: all 0.2s;
      color:#333;
      box-shadow: 5px/$md 5px/$md 5px/$md rgba(19, 19, 20, 0.15);
      img{
        width: 34px/$md;
        height: 34px/$md;
        margin: 0 auto;
      }
      p{
        font-size: 16px/$md;
      }
    }
  }
}
</style>
